import React, { useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { Truck, KeyRound, CheckCircle2, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/carrier-vendors`;

export default function CarrierSetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [done, setDone] = useState(false);

  const submit = async () => {
    setErr("");
    if (pw.length < 8) return setErr("Password must be at least 8 characters");
    if (pw !== pw2) return setErr("Passwords do not match");
    setBusy(true);
    try {
      await axios.post(`${API}/set-password`, { token, password: pw });
      setDone(true);
    } catch (e) { setErr(e.response?.data?.detail || "Could not set password"); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-7 shadow-sm">
        <div className="mb-5 flex items-center gap-3">
          <div className="rounded-xl bg-orange-600 p-2 text-white"><Truck size={22} /></div>
          <div>
            <h1 className="text-lg font-bold text-slate-800">Carrier Portal — Set Password</h1>
            <p className="text-sm text-slate-500">Europacific tender & spot bidding portal</p>
          </div>
        </div>
        {done ? (
          <div className="text-center" data-testid="carrier-setpw-done">
            <CheckCircle2 className="mx-auto mb-2 text-green-600" size={36} />
            <p className="text-sm text-slate-600">Password set. You can now sign in to the Carrier Portal.</p>
            <button data-testid="carrier-setpw-login" onClick={() => navigate("/login")}
              className="mt-4 w-full rounded-lg bg-orange-600 py-2.5 font-semibold text-white">Go to login</button>
          </div>
        ) : (
          <>
            {err && <div data-testid="carrier-setpw-error" className="mb-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700">{err}</div>}
            <label className="block mb-3">
              <span className="text-xs font-medium text-slate-600">New password</span>
              <input type="password" data-testid="carrier-setpw-pw" value={pw} onChange={(e) => setPw(e.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 focus:outline-none" />
            </label>
            <label className="block mb-4">
              <span className="text-xs font-medium text-slate-600">Confirm password</span>
              <input type="password" data-testid="carrier-setpw-pw2" value={pw2} onChange={(e) => setPw2(e.target.value)}
                className="mt-1 w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 focus:outline-none" />
            </label>
            <button data-testid="carrier-setpw-submit" disabled={busy} onClick={submit}
              className="flex w-full items-center justify-center gap-2 rounded-lg bg-orange-600 py-2.5 font-semibold text-white disabled:opacity-50">
              {busy ? <Loader2 className="animate-spin" size={18} /> : <KeyRound size={18} />} Set password
            </button>
          </>
        )}
      </div>
    </div>
  );
}
